import { AccountSwitcher } from '../shared/account-switcher';
import { ReviewsCounter } from '../shared/reviews-counter';

const MobileNavbar = () => (
  <header className="sticky -top-[1px] left-0 flex items-center justify-between w-screen p-4 bg-background z-20 drop-shadow-sm border-b border-border lg:hidden">
    <ReviewsCounter />
    <AccountSwitcher />
  </header>
);

export { MobileNavbar };
